module.exports = __webpack_public_path__ + "img/806.ce8267c8.png";